export const displayModeMixin = {
  inject: {
    dashboardDisplayMode: {
      default: () => null,
    },
  },
  computed: {
    displayMode() {
      return this.dashboardDisplayMode?.mode || "absolute";
    },
  },
};
